<template>
    <div class="row">
      <div class="col-sm-12 col-md-8 col-lg-7 mx-auto">
        <card :header-text="`Hola ${this.user.nombres}!`">
          <div class="card-body card-block">
            Lista de cosas que puedes hacer:
            <br>
            <br>
            <router-link :to="{name: 'crear-inspirador'}" >
              <button type="button" class="btn btn-success col-md-10 offset-md-1 mt-2"><i class="fa fa-plus"></i>&nbsp; Agregar inspirador</button>
            </router-link>
            <router-link :to="{name: 'inspiradores'}" >
              <button type="button" class="btn btn-success col-md-10 offset-md-1 mt-2"><i class="fa fa-eye"></i>&nbsp; Ver mis inspiradores</button>
            </router-link>
            <b-button v-b-modal.modal-1 class="btn btn-success col-md-10 offset-md-1 mt-2"><i class="fa fa-graduation-cap"></i>&nbsp; Tomar curso</b-button>
          </div>
        </card>
      </div>
      <b-modal id="modal-1" title="¡Importante!">
          <div class="text-center">
            <p class="my-4">Para iniciar el curso, debes registrarte como un usuario de nuestra plataforma de aprendizaje utilizando el mismo correo electrónico que acabas de ingresar en el sistema</p>
            <img src="../../images/popUpExplaination.png" alt="Vista de ejemplo de registro">
            <div class="col-md-12">
              <a href="https://redvolucion.asegest.com/login/index.php" target="_blank">
                <button type="button" class="btn-primary"><u>Ingresa aquí y crea tu cuenta en el botón indicado por la flecha roja</u></button>
              </a>
            </div>
            <p><small>¡Recuerda <b>utilizar el mismo correo electrónico</b>!</small></p>
            <p>Es muy importante que recuerdes tu clave de ingreso, la necesitarás cuando regreses a cargar tu historia inspiradora.</p>
            <h3>!Bienvenido!</h3>
          </div>
        <div slot="modal-footer">
        </div>
      </b-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
  },
  computed: {
    ...mapState('user', [
      'user'
    ])
  }
}
</script>
